import {AUTH_TYPE, isLoginPageMounted} from '@Libraries/login-signup-library';
import {setPendingTwoFactorVerificationCallback} from '@Libraries/two-factor-authentication-library';
import {openTwoFactorAuthenticationVerificationModal} from '@Modals/two-factor-authentication-verification-modal/two-factor-authentication-verification-modal.library';
import type {TwoFactorAuthenticationVerificationPanelProps} from '@Panels/two-factor-authentication-verification-panel/two-factor-authentication-verification-panel.types';
import {useUpdateAuthFormTypes} from '@Hooks/login-signup/useUpdateAuthFormTypes';

interface OpenTwoFactorVerification {
  openTwoFactorVerification: (options?: TwoFactorAuthenticationVerificationPanelProps) => void;
}

/**
 * The login page verifies 2FA in its own inline panel; every other surface — the in-editor auth modal,
 * account settings, the reset-password page — keeps the dialog. Callers state their intent once and this
 * picks the presentation, so no entry point has to know which surface it is rendered on.
 */
export const useOpenTwoFactorVerification = (): OpenTwoFactorVerification => {
  const {updateAuthTypes} = useUpdateAuthFormTypes();

  const openTwoFactorVerification = (options: TwoFactorAuthenticationVerificationPanelProps = {}): void => {
    if (!isLoginPageMounted()) {
      openTwoFactorAuthenticationVerificationModal(options);
      return;
    }

    setPendingTwoFactorVerificationCallback(options.onVerificationSuccessCallback ?? null);
    updateAuthTypes(AUTH_TYPE.TWO_FACTOR_VERIFICATION);
  };

  return {openTwoFactorVerification};
};
